export enum ActivityPreferredDateType {
  PREFERRED = 'preferred',
  EXCLUDED = 'excluded',
}

export interface ActivityPreferredDateDto {
  id: number;
  type: ActivityPreferredDateType;
  startDate: string;
  endDate: string;
}

export interface CreateActivityPreferredDatePayload {
  type: ActivityPreferredDateType;
  startDate: string;
  endDate: string;
}

export interface UpdateActivityPreferredDatePayload {
  type?: ActivityPreferredDateType;
  startDate?: string;
  endDate?: string;
}
